import { useEffect } from "react";

const useVersionCheck = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json");
        const data = await response.json();
        const currentVersion = localStorage.getItem("appVersion");

        if (currentVersion && currentVersion !== data.version) {
          localStorage.setItem("appVersion", data.version);
          window.location.reload(true);
        } else {
          localStorage.setItem("appVersion", data.version);
        }
      } catch (error) {
        console.error("Failed to fetch version.json", error);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, 60000); // Check every 60 seconds

    return () => clearInterval(interval);
  }, []);
};

export default useVersionCheck;
